import { localize } from "render/context/InternationalizationContext";

const Header = localize({
  en_GB: "Before we begin...",
  sv_SE: "Innan vi börjar...",
});

const Description = localize({
  en_GB: (
    <>
      <p>Would you want to activate the doctor scribe for your visit?</p>
      <p>
        Neko’s doctor scriber assists your doctor to deliver a full health
        summary at the end of your consultation.
      </p>
    </>
  ),
  sv_SE: (
    <>
      <p>Vill du aktivera läkarskribenten för ditt besök?</p>
      <p>
        Nekos läkarskribent hjälper din läkare att leverera en fullständig
        hälsosammanfattning i slutet av ditt besök.
      </p>
    </>
  ),
});

export const Trans = {
  Header,
  Description,
};
